// extracted by mini-css-extract-plugin
export default {"root":"TextArea-module_root__CaLXu","invalid":"TextArea-module_invalid__eJlit"};